<script setup lang="ts">
import { useRoute, useRouter } from "vue-router";

import { useAdminSession } from "../lib/session";

const route = useRoute();
const router = useRouter();
const session = useAdminSession();

const roleNames = {
  support: "客服查詢",
  ops: "營運處理",
  finance: "財務管理",
  superadmin: "系統管理"
};

async function logOut() {
  await session.logOut();
  await router.replace({ name: "login" });
}
</script>

<template>
  <div class="admin-frame">
    <aside class="side-rail">
      <RouterLink class="brand-lockup" to="/orders" aria-label="清和書院營運台首頁">
        <span class="brand-seal" aria-hidden="true">清<br />和</span>
        <span><strong>清和書院</strong><small>營運台</small></span>
      </RouterLink>

      <nav class="primary-nav" aria-label="主要功能">
        <RouterLink to="/orders" :class="{ active: route.path.startsWith('/orders') }">
          <span class="nav-mark" aria-hidden="true"></span>
          訂單與報告
        </RouterLink>
        <span class="nav-disabled" title="第二階段開放">
          <span class="nav-mark" aria-hidden="true"></span>
          退款處理 <small>稍後</small>
        </span>
        <span class="nav-disabled" title="第二階段開放">
          <span class="nav-mark" aria-hidden="true"></span>
          權限管理 <small>稍後</small>
        </span>
      </nav>

      <div class="rail-foot">
        <p class="rail-caption">登入身分</p>
        <p class="operator-name">{{ session.admin.value?.displayName }}</p>
        <p class="operator-meta">
          {{ session.admin.value ? roleNames[session.admin.value.role] : "" }}
        </p>
        <button class="text-button" type="button" @click="logOut">登出後台</button>
      </div>
    </aside>
    <main class="admin-main">
      <slot />
    </main>
  </div>
</template>
